import { Component, OnInit, Input } from "@angular/core";
import { CategoryChangeLog } from "../../../models/category/category-change-log";
import { CategoriesService } from "../../../services/categories.service";

@Component({
	selector: 'change-log-grid',
	templateUrl: './change-log.grid.html',
	styleUrls: [
		'./change-log.grid.scss',
	]
})
export class ChangeLogGrid implements OnInit {

	categoryChangeLogs: CategoryChangeLog[] = [];

	@Input() categoryId: number;
	@Input() entityId: number;
	@Input() isMultiple: boolean = false;
	@Input() categoryEntityIds: { [categoryId: number]: number[] } = {};

	constructor(
		private categoriesService: CategoriesService) {
	}

	ngOnInit(): void {
		if (this.isMultiple) {
			this.categoriesService.getChangeLogForMultipleEntity(this.categoryEntityIds)
				.subscribe(result => {
				this.categoryChangeLogs = result;
			});
		}	
		else {
			this.categoriesService.getChangeLogForEntity(this.categoryId, this.entityId)
				.subscribe(result => {
					this.categoryChangeLogs = result;
				});
		}
	}
}
